import { MapSettingsService } from '@addins/core/map';
import { CustomComponentsService } from '@addins/core/settings';
import { DestinationType } from '@addins/external-itinerary';
import { Injectable } from '@angular/core';
import { Coordinate } from '@models/coordinate';
import { CLocation } from '@models/imported/SagaSchema/CLocation';
import { NavigationToolsProviderService } from '@services/navigation-tools-provider/navigation-tools-provider.service';
import { AddinExecute, Execute } from '@techwan/ionic-core';
import { ExternalItinerarySettingsComponent } from '../../../components/external-itinerary-settings/external-itinerary-settings.component';
import { ExternalItineraryProviderService } from '../../external-itinerary-provider/external-itinerary-provider.service';
import { StartItineraryService } from '../../start-itinerary/start-itinerary.service';

@AddinExecute({
  name: 'external-itinerary'
})
@Injectable()
export class StartItineraryMenuService extends Execute {
  public constructor(
    private navigationTools: NavigationToolsProviderService,
    private customSettingsComponents: CustomComponentsService,
    private startItineraryService: StartItineraryService,
    private mapSettingsService: MapSettingsService,
    private externalItineraryProvider: ExternalItineraryProviderService
  ) {
    super();
  }

  execute() {
    this.externalItineraryProvider.setup();
    this.customSettingsComponents.add(ExternalItinerarySettingsComponent);

    this.navigationTools.add({
      name: 'ExtItinerary',
      icon: 'assets/icons/navigation/external-navigation.svg',
      navigateTo: location => this.navigateTo(location),
      position: 400
    });
  }

  private navigateTo(location: CLocation) {
    const coordinate: Coordinate = this.getCoordinateWithProjection(location);
    this.startItineraryService.navigateTo({
      location: coordinate,
      destinationType: DestinationType.CallCard,
      destinationId: location.CallCardId
    });
  }

  private getCoordinateWithProjection(location: CLocation): Coordinate {
    return {
      x: location.coordinate.x,
      y: location.coordinate.y,
      epsg: location.coordinate.epsg || this.mapSettingsService.getSystemProjection()
    };
  }
}
